import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConnectionService } from './connection.service';

export interface InvoiceImportStatus {
  state: string; model: string; total: number; saved: number; skipped: number;
  failed: number; pending: number; preparing?: boolean; canResume: boolean;
  currentInvoice?: number; pauseRequested?: boolean; error?: string;
  retryAt?: string; retryAttempt?: number;
  inputTokens?: number; outputTokens?: number; offset: number;
  records: { invoiceNumber?: number; state: string; error?: string; summary?: string;
    tags?: string[]; updatedAt: string; memoryId?: string }[];
}

@Injectable({ providedIn: 'root' })
export class InvoiceMemoryImportService {
  constructor(private http: HttpClient, private connection: ConnectionService) {}
  status(offset = 0) { return this.http.post<InvoiceImportStatus>(this.connection.address + '/invoice-memory-import/status', { offset }, { headers: this.getHeaders() }); }
  start(retryFailed = false) { return this.http.post(this.connection.address + '/invoice-memory-import/start', { retryFailed }, { headers: this.getHeaders() }); }
  pause() { return this.http.post(this.connection.address + '/invoice-memory-import/pause', {}, { headers: this.getHeaders() }); }

  private getHeaders(): HttpHeaders {
    const token = this.connection.activeConnection?.token || localStorage.getItem('token') || '';
    return token ? new HttpHeaders({ authtoken: token }) : new HttpHeaders();
  }
}
